(function () {
  const initCollapsibleContent = () => {
    $(".collapsible-content__toggle").each(function (index, element) {
      if ($(this).hasClass("content_started")) {
        return "";
      }
      $(this).addClass("content_started");
      $(element).on("click", function () {
        const parent = $(this).parent();

        if (!parent.hasClass("active")) {
          parent.siblings(".collapsible-content__item.active").removeClass("active");
          parent.addClass("active");
          $(this)
            .closest(".collapsible-content__items")
            .find(".collapsible-content__answer")
            .stop()
            .slideUp(300);
          $(this).next().stop().slideDown(300);
        } else {
          parent.removeClass("active");
          $(this).next().stop().slideUp(300);
        }
      });
    });

    $(".collapsible-content__item").mouseenter(function (event) {
      const element = $(this);
      element.removeClass("collapsible-content__item--opacity");
      element.siblings().addClass("collapsible-content__item--opacity");
      element.mouseleave(() => {
        element.siblings().removeClass("collapsible-content__item--opacity");
      });
    });
  };

  const filterFaqByCategory = (section, activeCategory) => {
    section.find('.collapsible-content__item').each(function () {
      const item = $(this);
      const category = item.data('category') || 'tab_1';
      if (category === activeCategory) {
        item.show();
      } else {
        item.hide();
        item.removeClass('active');
        item.find('.collapsible-content__answer').stop().slideUp(0);
      }
    });
  };

  const initFaqTabs = () => {
    $('.faq-redesign').each(function () {
      const section = $(this);
      const tabs = section.find('.faq-redesign__tab');
      if (!tabs.length) return;

      // Apply initial filter based on the pre-marked active tab
      const initTab = tabs.filter('.faq-redesign__tab--active').first();
      if (initTab.length) {
        filterFaqByCategory(section, initTab.data('tab'));
      }

      tabs.on('click', function () {
        const tab = $(this);
        if (tab.hasClass('faq-redesign__tab--active')) return;
        tabs.removeClass('faq-redesign__tab--active').attr('aria-selected', 'false');
        tab.addClass('faq-redesign__tab--active').attr('aria-selected', 'true');
        filterFaqByCategory(section, tab.data('tab'));
      });
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    initCollapsibleContent();
    initFaqTabs();
    document.addEventListener("shopify:section:load", function () {
      initCollapsibleContent();
      initFaqTabs();
    });
  });
})();

